<template>
  <div>
    <!-- 檢核項目 -->
    <base-box title="檢核項目" >
      <span style="color: red;">*上傳檔案若為身分證影本或涉及保戶機敏文件註明（限XX 人壽辦理XX（填投保或保全）使用）</span>
      <check-item ref="componentsRef"
                  v-model="checkItemResult"
                  :ins-file-limit="insFileLimit"
                  :init-file-item="insFileList"
                  :init-data="checkItemData"
                  :is-preview="isPreview"
                  :tab-step="tabStep"
                  @upload-file="onUpload"
                  @delete-file="onDelete"
                  @file-picker="filePickerLog"
                  @update-file-item="fetchFileItem"
                  @set-tab-done="setTabDone"
                  @next-tab="nextStepHandler"
                  @set-validate-num="setValidateNum"
                  ></check-item>
    </base-box>
    <base-btn >
      <btn-lg-default class="float-left"
                      :disabled="isPreview"
                      @click="resetPropHandler">全部清除</btn-lg-default>
      <btn-lg-default @click="preStepHandler">上一步</btn-lg-default>
      <btn-lg-primary @click="nextStepPropHandler">下一步</btn-lg-primary>
    </base-btn>
    <btn-lg-default style="position: fixed;top: 300px;right: 30px;min-width: 126px;max-width: 126px;" @click="preStepHandler" >上一步</btn-lg-default>
    <btn-lg-primary style="position: fixed;top: 360px;right: 30px;min-width: 126px;"  @click="nextStepPropHandler" >下一步</btn-lg-primary>
  </div>
</template>

<script>

import ProposalStepsBase from './/ProposalStepsBase'
import CheckItem from '@/components/Ins/Policy/CheckItem.vue'
import store from '@/store'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('ins')
import { withDebounce } from '@/utils'
import { filter } from 'lodash'
export default {

  extends: ProposalStepsBase,

  components: { CheckItem },

  data () {
    return {
      preSignState: 'N', // 是否為異常件
      checkItemData: null, // 來源資料(名稱、輸入框)
      insFileList: null, // 來源資料(檔案列表)
      checkItemResult: {}, //結果物件，暫存用
      stepCode: 'M' === this.polInsureType ? 'INS_S4' : 'REMOTE_S4',
    }
  },

  computed: {
    insFileLimit () {
      // 可上傳檔案數量(ADM_PARMD-S01)
      let { parameterValue: limit } = this.insParameters['FILE_LIMIT']
      limit = parseInt(limit)
      return limit
    }
  },

  beforeRouteEnter (to, from, next) {
    const { transCode,checkItemObject } = to.params.propKey
    const reqPolf = store.dispatch('ins/fetchInsPoliciesPolf', { transCode, fileGroup: ['VALIDATE'] }) // 檔案列表
    Promise.all([ reqPolf]).then(r => {
      const [  polf ] = r
      next(vm =>{
        vm.insFileList = polf.data
        vm.checkItemData = checkItemObject
        if (!vm.isPreview) {
          vm.$nextTick(() => {
            setTimeout(() => {
              vm.$refs['componentsRef'].doValidate()
            }, 0)
          })
        }
      })
    })
  },
  watch: {
    changedFlag (v) {
      if (v) {
        this.$setTabDone(this.tabStep, false )
      }
    },
  },
  methods: {
    ...mapActions([
      'fetchInsPoliciesPolf',
      'postUpdFileBase64',
      'delFile',
      'delAllFile',
      'postCheckItem',
    ]),
    onUpload (updFileObj) { // 上傳檔案至DB儲存
      const { insFileList } = this
      let fileArray =  filter(insFileList, function(f) { // 取得該列別已上傳檔案數
        return f.fileType == updFileObj.fileType
      })
      let fileSize = fileArray.length ? fileArray.length : 0
      if (this.insFileLimit <= fileSize) {
        this.$alert('已超過上傳檔案數量限制: ' + this.insFileLimit)
      } else if (updFileObj && updFileObj.files && updFileObj.fileType) {
          const opt = {
          files: updFileObj.files,
          fileName: updFileObj.fileName,
          base64Str: updFileObj.base64Str,
          fileType: updFileObj.fileType,
          stepCode: this.stepCode,
          transCode: this.transCode
        }
        this.postUpdFileBase64(opt).then(r => {
          this.$postUserAccessLog({ progClassName: 'checkItem_upload', methodName: '上傳', stepCode: this.tabStep })
          this.fetchInsPoliciesPolf({ // 重取檔案列表
            transCode: this.transCode,
            fileGroup: ['VALIDATE']
          }).then(r => {
              this.insFileList = r.data
          })
        })
      }
    },
    onDelete (fileCode) { // 刪除
      if (fileCode && fileCode.length) {
        const opt = {
          fileCode: fileCode,
          stepCode: this.stepCode,
          transCode: this.transCode
        }
        this.delFile(opt).then(r => {
          this.fetchInsPoliciesPolf({ // 重取檔案列表
            transCode: this.transCode,
            fileGroup: ['VALIDATE']
          }).then(r => {
              this.insFileList = r.data
          })
        })
      }
    },
    filePickerLog () {
      this.$postUserAccessLog({ progClassName: 'checkItem_filePicker', methodName: '選擇檔案', stepCode: this.tabStep })
    },
    fetchFileItem (item) { // 從子元件取得上傳檔案列表
      this.insFileList = item
    },
    allHasTmpFileStatus (v) { // 檢查是否還有檔案沒上傳
      this.allHasTmpFile = v
    },
    setValidateNum (obj) {
      this.$emit('set-validate-num', obj)
    },
    resetPropHandler () { // 為了要取得物件資料
      this.$postUserAccessLog({ progClassName: 'checkItem_clear', methodName: '全部清除', stepCode: this.tabStep })
      this.delAllFile({transCode: this.transCode}).then(() => {
          this.insFileList = [] //清空檔案列表
          this.changedFlag = true
          this.$refs['componentsRef'].resetHandler()
          this.$emit('go-top')
      })
    },
    nextStepPropHandler () { // 為了要取得物件資料
      this.$refs['componentsRef'].nextStepHandler()
    },
    setTabDone (step, flag) {
      this.$setTabDone(step, flag)
    },
    nextStepHandler: withDebounce(function (result) {
      if (this.isPreview) {
        this.$postUserAccessLog({ progClassName: 'checkItem_next', methodName: '下一步', stepCode: this.tabStep })
        this.$nextStepHandler()
      } else {
        this.$set(result, 'executeFrom', 'nextStep')
        this.$set(result, 'transCode', this.transCode)
        this.$postUserAccessLog({ progClassName: 'checkItem_next', methodName: '下一步', stepCode: this.tabStep  })
        this.postCheckItem(result).then(r => {
          this.$nextStepHandler()
        })
      }
    }),
    preStepHandler: withDebounce(function () {
      this.$postUserAccessLog({ progClassName: 'checkItem_prev', methodName: '上一步', stepCode: this.tabStep })
      this.$preStepHandler()
    }),
    tempSave: withDebounce(function () {
      let vm = this
      // this.$changedReset()
      const {checkItemResult } = this
      this.$set(checkItemResult, 'executeFrom', 'tempSave')
      this.postCheckItem(checkItemResult).then(r => {
        this.$postUserAccessLog({ progClassName: 'checkItem_tempsave', methodName: '暫存', stepCode: this.tabStep })
        vm.$alert('暫存成功')
      })
    }),
  },

}
</script>
